// src/multiselect/src/components/react-select-components/control.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var Control = (props) => {
  return /* @__PURE__ */ jsx("div", { className: "rounded border border-surface-border bg-surface-light p-1 pr-3 outline-none -outline-offset-1 focus-within:outline-2 focus-within:outline-interactive-primary", children: /* @__PURE__ */ jsx(components.Control, { ...props }) });
};

export {
  Control
};
